import { config } from '../config';
import { getHeaders } from './getHeaders';

export const sendConfirmationToken = (token: string) =>
  fetch(`${config.apiBaseUrl}/api/v1/roofer/confirmation`, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify({ token }),
  });
